<template>
  <div id="app">
    <NavBar/>
    <router-view/>
    <Footer/>
  </div>
</template>

<script>
import NavBar from "./components/NavBar/NavBar";
import Footer from "./components/Footer/Footer";

export default {
  name: 'App',
  components: {
      Footer,
      NavBar
  }
}
</script>

<style lang="scss">

  @import "app";

  #app {
    font-family: 'Roboto', sans-serif;
  }
</style>
